import React, { useState, useEffect } from "react";
import { AnimatePresence, motion } from "framer-motion";

const Counter = ({ show }) => {
  const [value, setValue] = useState(0);
  let interval;
  useEffect(() => {
    if (show) {
      interval = setInterval(() => {
        setValue((prevState) => {
          if (prevState >= 99) {
            clearInterval(interval);
            return 100;
          } else {
            return prevState + 1;
          }
        });
      }, 20);
    }
    return () => clearInterval(interval);
  }, [show]);

  return (
    <AnimatePresence>
      {show && (
        <motion.div id="counter">
          <motion.p
            initial={{ opacity: 0, y: 2 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: 2 }}
            transition={{ ease: "easeInOut" }}
          >
            {value}
          </motion.p>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default Counter;
